/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

const defaultProps = {
    ...commonDefaultProps,
    size: 'small',
};

const Grid = (props) => {
    let sizeClassName = 'c-grid--s';
    switch (props.size) {
        case 'small':
            sizeClassName = 'c-grid--s';
            break;
        case 'medium':
            sizeClassName = 'c-grid--m';
            break;
        case 'large':
            sizeClassName = 'c-grid--l';
            break;
        default:
            sizeClassName = 'c-grid--s';
    }
    const classNames = [
        'c-grid',
        sizeClassName,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Grid.propTypes = propTypes;

Grid.defaultProps = defaultProps;

export default Grid;
